import { Link } from 'react-router-dom';

function PostTags({ tags = [] }) {
    if (!Array.isArray(tags) || tags.length === 0) return null;

    return (
        <div className="post-tags" aria-label="Post topics">
            {tags.map((tag) => (
                <Link
                    className="post-tag"
                    key={tag}
                    to={`/search?tag=${encodeURIComponent(tag)}`}
                    aria-label={`Find posts tagged ${tag}`}
                >
                    {tag}
                </Link>
            ))}
        </div>
    );
}

export default PostTags;
